<template>
    <v-btn
        icon
        v-if="hasSupport"
        v-on:click="click"
        :color="showDialog ? 'green' : 'default'"
    >
        <v-icon>mdi-face-agent</v-icon>
    </v-btn>
</template>

<script>
export default {
    methods: {
        click() {
            this.$store.commit('support/switchDialogState')
        },
    },
    computed: {
        showDialog() {
            return this.$store.getters['support/showDialog']
        },

        hasSupport() {
            return this.$store.getters['reseller/hasSupport']
        },
    },
}
</script>
